import { T } from '@transifex/react'
import React from 'react'

export const OpenCashDrawer = () => {
  return (
    <p className="vd-show-print">
      **** <T _str="Open Cash Drawer" /> ****
    </p>
  )
}
